import React, {useState, useEffect, useRef, useCallback} from 'react';
import styles from './PhotoChooser.module.scss'
import {useSelector} from "react-redux";

const PhotoChooser = () => {

    const wrapSelection = useSelector(state => state.wrapSelection);
    const prevWrap = useRef(wrapSelection);
    const prevIndex = useRef(0);

    const getDefaultPhoto = useCallback(()=>{

        let defaultGallery = wrapSelection.product.gallery ? wrapSelection.product.gallery[wrapSelection.design.sku] : wrapSelection.product.models[0].gallery[wrapSelection.design.sku]
        let activeGallery = wrapSelection.model && wrapSelection.model.gallery ? wrapSelection.model.gallery[wrapSelection.design.sku] : defaultGallery;

        let designChange = prevWrap.current.design && wrapSelection.design && prevWrap.current.design.sku !== wrapSelection.design.sku;

        let index = designChange && activeGallery.length > 1 ? prevIndex.current : 0;

        return activeGallery[index]
    },[wrapSelection]);

    const [selectedPhoto, setSelectedPhoto] = useState(getDefaultPhoto);

    useEffect(()=>{

        /** new product, reset selected **/
        let defaultGalleryPhoto = getDefaultPhoto();
        setSelectedPhoto(defaultGalleryPhoto);

        prevWrap.current = wrapSelection;
    }, [wrapSelection, setSelectedPhoto, getDefaultPhoto]);

    function updateSelection(photo, index){
        prevIndex.current = index;
        setSelectedPhoto(photo);
    }

    function buildGallery(){

        let defaultGallery = wrapSelection.product.gallery ? wrapSelection.product.gallery[wrapSelection.design.sku] : wrapSelection.product.models[0].gallery[wrapSelection.design.sku]
        let modelGallery = wrapSelection.model && wrapSelection.model.gallery ? wrapSelection.model.gallery[wrapSelection.design.sku] : defaultGallery;

        return modelGallery.map((photo, index) => (
            <li key={index} onClick={() => updateSelection(photo,index)}
                className={photo === selectedPhoto ? styles.selected : ""}
                style={{backgroundImage: `url(${photo})`}}/>
        ))
    }

    return (
        <div aria-hidden={true} className={`${styles.photoChooser}`}>
            <div className={styles.photoOptions}>
                <ul>
                    {buildGallery()}
                </ul>
            </div>
            <div className={styles.photo} style={{backgroundImage: `url(${selectedPhoto})`}}/>
        </div>
    );
};

export default PhotoChooser
